import React from 'react'
import { usePropertiesContext } from '../../context/PropertiesContext'
import SingleListingSlider from './SingleListingSlider'

const HomeSliderListing = () => {
    const { properties, loading } = usePropertiesContext()

    // Get properties to display (limit to 6)
    const displayProperties = properties?.slice(0, 6) || []
    return (
        <>
            {loading ? (
                <div className="text-center fs-ss-18 lh-1-7em fw-300 col-md-8 mx-auto text-white py-5">Loading...</div>
            ) : (
                <>
                    {properties.length === 0 ? (
                        <div className="text-white fs-ss-18 lh-1-7em fw-300 col-md-8 mx-auto text-center py-5">
                            No Property Found!
                        </div>
                    ) : (
                        <div className="container-fluid px-0">
                            <div className="row g-4">
                                {displayProperties.map((property, index) => (
                                    <div key={index} className="col-md-4 col-sm-6">
                                        <SingleListingSlider item={property} images={property.images} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    )
}

export default HomeSliderListing
